// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__JS6A9","alert":"SettungsInbox_alert__X0V0f"};